const FIELD_LIMITS = {
  treatmentDetails: 256,
  notes: 3000,
  locationDescription: 96,
}

function limitText(value, max) {
  const text = value == null ? '' : String(value)
  if (text.length <= max) return text
  return text.slice(0, max - 3) + '...'
}

module.exports = {
  FIELD_LIMITS,
  limitText,
}
